import { useGlobalStore } from "./store";
import { queryClient } from "@app/config/api/api";
import type { Team, UserDetails } from "@globals";

export const updateUser = (user: UserDetails | null) => {
  useGlobalStore.setState(() => ({
    user
  }));
};

export const updateSelectedTeam = async (team: Team | null) => {
  useGlobalStore.setState(() => ({
    selectedTeam: team
  }));

  // Invalidate all queries to refresh data for the new team context.
  await queryClient.invalidateQueries();
};
